// extracted by mini-css-extract-plugin
export default {"title":"alamat-lengkap-properti_title__Tkcsj","input-wrapper":"alamat-lengkap-properti_input-wrapper__13quf","info":"alamat-lengkap-properti_info__cRSzh"};